<template>
  <Modal
      v-model="_value"
      width="500"
      title="短信初始化BSJ终端"
      @on-visible-change="visibleChange"
      ok-text="发送"
      @on-ok="onOk">
    <Form ref="loginForm" :model="deviceParams" :rules="rules" >
      <FormItem prop="terminalNum">
        <label style="display: inline-block; width: 200px;">主机号(初始化必填)</label>
        <Input style="display: inline-block; width: 200px;" v-model="deviceParams.terminalNum" placeholder="请输入主机号">
        </Input>
      </FormItem>
      <FormItem prop="ip">
        <label style="display: inline-block; width: 200px;">服务器IP</label>
        <Input style="display: inline-block; width: 200px;" v-model="deviceParams.ip" placeholder="请输入服务器IP">
        </Input>
      </FormItem>
      <FormItem prop="port">
        <label style="display: inline-block; width: 200px;">服务器端口</label>
        <Input style="display: inline-block; width: 200px;" v-model="deviceParams.port" placeholder="请输入服务器端口">
        </Input>
      </FormItem>
      <FormItem prop="apn">
        <label style="display: inline-block; width: 200px;">APN</label>
        <Input style="display: inline-block; width: 200px;" v-model="deviceParams.apn" placeholder="请输入APN">
        </Input>
      </FormItem>
      <FormItem prop="accOn">
        <label style="display: inline-block; width: 200px;">ACC开上传间隔</label>
        <InputNumber :min="1" :step="1" style="display: inline-block; width: 200px;" v-model="deviceParams.accOn" placeholder="请输入ACC开上传间隔">
        </InputNumber>
      </FormItem>
      <FormItem prop="accOff">
        <label style="display: inline-block; width: 200px;">ACC关上传间隔</label>
        <InputNumber :min="1" :step="1" style="display: inline-block; width: 200px;" v-model="deviceParams.accOff" placeholder="请输入ACC关上传间隔">
        </InputNumber>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'initbsjsmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '客户名称不能为空', trigger: 'blur' }
          ]
        }
      },
      phoneNumRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '联系电话不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        simNum:null,
        deviceParams: {
          ip:null,
          port:null,
          apn:null,
          terminalNum:null,
          accOn:null,
          accOff:null
        }
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onOk() {
        let content = '<SPBSJ*P:BSJINI'

        if(this.deviceParams.ip && this.deviceParams.port && this.deviceParams.ip !== '' && this.deviceParams.port !== ''){
          content = content + '*T:' + this.deviceParams.ip + ',' + this.deviceParams.port
        }

        if(this.deviceParams.terminalNum && this.deviceParams.terminalNum !== ''){
          content = content + '*N:' + this.deviceParams.terminalNum
        }

        if(this.deviceParams.apn && this.deviceParams.apn !== ''){
          content = content + '*A:' + this.deviceParams.apn
        }

        if(this.deviceParams.accOn && this.deviceParams.accOn !== ''){
          content = content + '*C:' + this.deviceParams.accOn
        }

        if(this.deviceParams.accOff && this.deviceParams.accOff !== ''){
          content = content + '*O:' + this.deviceParams.accOff
        }

        content = content + '>'

        store.dispatch('ShortMessageServ_Send', {params: {simNum: this.simNum, content: content}}).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
          this.deviceParams.ip = '112.74.160.123'
          this.deviceParams.port = 2010
          this.deviceParams.apn = 'CMNET'
          this.deviceParams.terminalNum = null
          this.deviceParams.accOn = 15
          this.deviceParams.accOff = 120
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
